// Friends system TypeScript definitions shared across platforms

export interface Friend {
  id: string;
  user_id: string;
  friend_id: string;
  status: 'active' | 'blocked' | 'pending';
  created_at: string;
  updated_at: string;
}

export interface FriendRequest {
  id: string;
  sender_id: string;
  receiver_id: string;
  status: 'pending' | 'accepted' | 'rejected' | 'cancelled';
  message?: string;
  created_at: string;
  updated_at: string;
}

export interface FriendTag {
  id: string;
  user_id: string;
  friend_id: string;
  tag_name: string;
  created_at: string;
  updated_at: string;
}

export interface FriendWithProfile {
  id: string;
  user_id: string;
  friend_id: string;
  status: string;
  created_at: string;
  updated_at: string;
  display_name?: string;
  avatar_url?: string;
  username?: string;
}

export interface FriendWithTags extends FriendWithProfile {
  tags: string[];
}

export interface FriendTagWithProfile {
  id: string;
  user_id: string;
  friend_id: string;
  tag_name: string;
  created_at: string;
  updated_at: string;
  friend_display_name?: string;
  friend_avatar_url?: string;
  friend_username?: string;
}

export interface FriendSelectionOption {
  friend_id: string;
  display_name: string;
  avatar_url?: string;
  tags: string[];
  selected: boolean;
}

export interface FriendTagStats {
  tag_name: string;
  usage_count: number;
}

export interface AddFriendTagRequest {
  friend_id: string;
  tag_name: string;
}

export interface RemoveFriendTagRequest {
  friend_id: string;
  tag_name: string;
}

export interface UpdateFriendTagsRequest {
  friend_id: string;
  tags: string[];
}

export interface GetFriendsByTagsRequest {
  tag_names: string[];
}

export interface FriendsByTagsResponse {
  friend_id: string;
  friend_display_name: string;
  friend_avatar_url?: string;
  friend_username?: string;
  matching_tags: string[];
}

export const PRESET_FRIEND_TAG_KEYS = [
  'presetTagCoworker',
  'presetTagClassmate',
  'presetTagNeighbor',
  'presetTagRoommate',
  'presetTagFamily',
  'presetTagGymBuddy',
  'presetTagGameBuddy',
  'presetTagLunchBuddy',
  'presetTagTravelBuddy',
  'presetTagStudyBuddy',
  'presetTagWorkPartner',
] as const;

export const PRESET_FRIEND_TAGS = [
  '同事',
  '同学',
  '邻居',
  '室友',
  '家人',
  '健身伙伴',
  '游戏伙伴',
  '午餐伙伴',
  '旅行伙伴',
  '学习伙伴',
  '工作伙伴',
] as const;

export type PresetFriendTag = (typeof PRESET_FRIEND_TAGS)[number];
export type PresetFriendTagKey = (typeof PRESET_FRIEND_TAG_KEYS)[number];

export interface FriendFilter {
  searchText?: string;
  selectedTags?: string[];
  showAllFriends?: boolean;
}

export interface FriendGroup {
  tag_name: string;
  friends: FriendWithProfile[];
}

export interface FriendsGroupedByTags {
  [tagName: string]: FriendWithProfile[];
}
